import { Component } from '@angular/core';

@Component({
  selector: 'app-copy-rights',
  templateUrl: './copy-rights.component.html',
  styleUrl: './copy-rights.component.scss'
})
export class CopyRightsComponent {

}
